import { TweenMax } from 'gsap';
import App from '../../../vendor_core/core/src/App';
import GameEvents from '../../../vendor_core/core/src/const/GameEvents';
import GameModel from '../../../vendor_core/core/src/model/GameModel';
import SpinModel from '../../../vendor_core/core/src/model/SpinModel';
import SpinResultState from '../../../vendor_core/core/src/states/SpinResultState';
import UIController from '../../../vendor_core/core/src/ui/UIController';
import { UIStates } from '../../../vendor_core/core/src/ui/UIStates';
import ConsoleUtil from '../../../vendor_core/core/src/utils/ConsoleUtil';
import { DefaultLayers } from '../../../vendor_core/core/src/utils/Layers';
import ViewManager from '../../../vendor_core/core/src/utils/ViewManager';
import BBAnimationsHelper from '../utils/BBAnimationsHelper';
import BBReelGroup from '../view/BBReelGroup';
import AutoplayModel from '../../../vendor_core/core/src/model/AutoplayModel';
import CommandManager from '../../../vendor_core/core/src/commands/CommandManager';
import { Commands } from '../../../vendor_core/core/src/commands/CommandEnum';

export default class BBSpinResultState extends SpinResultState {
    protected skipping: boolean;
    protected delayTween: TweenMax = null;

    public enter(): void {
        super.enter();
    }
    protected setSkipWithSpace = () => {

    };
    protected stopReels() {
        GameModel.setSpinDelay(0);
        UIController.setState(UIStates.SPIN_RESULT);
        let reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
        .getCurrentScene()
        .getSubView("ReelGroup") as BBReelGroup;
        let reels = Array.from(Array(reelGroup.reels.length).keys());
        let result = SpinModel.getStopSymbolsForReels(reels);
        reelGroup.stop(result);
        // reelGroup.hideLinesAndInfo()
        App.dispatcher.once(
            GameEvents.ALL_REELS_STOPPED,
            () => {
                ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene().containers.get("reels").disableMask();
                // console.log(SoundController.currentSounds);
                // debugger
                BBAnimationsHelper.clearAnticipation();
                // if (this.delayTween) {
                //     this.delayTween.kill();
                // }
                // // SoundController.playSound(SoundVars.EFFECT_REEL_STOP);
                // this.delayTween = TweenMax.delayedCall(0.7, () => {
                    ConsoleUtil.red("Exit from Spin Result State");
                    // debugger
                    this.exit()
                // });
            },
            this
        );
    }

    protected checkAuto() {
        if (AutoplayModel.isAutoSpinActive()) {
            if (
                AutoplayModel.checkLossLimitReached() ||
                AutoplayModel.checkWinLimitReached(SpinModel.currentWin) ||
                AutoplayModel.checkTotalWinLimitReached() ||
                AutoplayModel.checkStopOnAnyWin(SpinModel.winAmount) ||
                AutoplayModel.checkStopOnBigWin(SpinModel.winAmount)
                // AutoplayModel.stopOnFeatureWin
            ) {
                // AutoplayModel.setAutoSpin(0);
                CommandManager.execute(Commands.STOP_AUTOPLAY);
                CommandManager.execute(Commands.CLEAR_AUTOPLAY_LIMITS);
            }
        }
    }
}
